import styled from 'styled-components';

const PageTopSectionStyle = styled.div`
	--distanceBackTop: var(--sp6x);
	--distanceButtonTop: var(--sp10x);

	.button-top-wrap {
		opacity: 0;
		padding-top: var(--distanceButtonTop);
	}

	.single-service-title {
		max-width: 80%;
	}

	.navigation-back {
		opacity: 0;
		width: fit-content;
		cursor: pointer;
	}

	.back-button {
		padding-top: var(--distanceBackTop);

		span:first-child {
			margin-left: 0 !important;
		}

		.text-back {
			position: relative;
			display: inline-block;
			overflow: hidden;

			&::after {
				content: '';
				position: absolute;
				left: 0;
				bottom: 0;
				height: 2px;
				width: 100%;
				background: currentColor;
				transform: translateX(0);
				transition: transform 0.3s ease;
			}

			&:hover::after {
				transform: translateX(100%);
			}
		}
	}

	&.ContainerWrap {
		margin-bottom: var(--titleToContent);

		&.underline {
			border-bottom: 2px solid var(--color2);
			padding-bottom: var(--sp8x);
		}

		.title {
			margin-top: calc(var(--titleToContent) / 2);
			margin-bottom: var(--titleToText);

			span {
				will-change: opacity;
				opacity: 0;
			}
		}

		.subtitle {
			margin-bottom: var(--textToDescription);
			white-space: pre-wrap;
			opacity: 0;
			will-change: opacity;
		}

		.description {
			white-space: pre-wrap;
			opacity: 0;
			will-change: opacity;
		}

		.servicesTop {
			--animationSize: 164px;
			--leftMarg: var(--sp8x);
			--bottomMarg: -18px;

			position: relative;

			.titleOther {
				letter-spacing: -1px;
				margin-top: calc(var(--titleToContent) / 2);
				margin-bottom: var(--titleToText);

				span:first-child {
					margin-left: var(--leftMarg);
					margin-bottom: var(--bottomMarg);
				}

				span {
					will-change: opacity;
					opacity: 0;
				}
			}
			.servicesTitle {
				position: relative;

				.servicesCounter {
					opacity: 0;
					position: absolute;
					top: 0;
					left: 0;
					transform: translateY(-65%);
				}
			}

			.servicesAnimationWrap {
				position: relative;
				width: 100%;
				height: var(--animationSize);
				right: 0;
				bottom: var(--sp3x);
				display: flex;
				justify-content: flex-end;
				padding-top: 50%;
				margin: var(--sp2x) 0 var(--sp5x);
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			--distanceBackTop: 0;
			--distanceButtonTop: var(--sp3x);

			.single-service-title {
				max-width: 100%;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.subtitle {
				max-width: 100%;
			}

			.single-service-title {
				max-width: 100%;
			}

			.description {
				&.long {
					max-width: 70%;
				}

				&.short {
					max-width: 77%;
				}
			}

			.servicesTop {
				--leftMarg: var(--sp15x);
				--bottomMarg: -48px;
				--animationSize: 140px;
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			--distanceBackTop: 0;
			--distanceButtonTop: var(--sp4x);

			.position_right {
				display: flex;
				justify-content: flex-end;
			}

			.servicesTop {
				.servicesTitle {
					.servicesCounter {
						transform: translateY(-50%);
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			--distanceBackTop: var(--sp3x);
			--distanceButtonTop: var(--sp5x);

			.servicesTop {
				.servicesAnimationWrap {
					position: absolute;
					padding-top: 25%;
					width: 20%;
					margin: 0;

					&.case-ziggy {
						padding-top: 40%;
						width: 35%;
					}
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			.subtitle {
				max-width: 86%;
			}

			.description {
				&.long {
					max-width: 70%;
				}

				&.short {
					max-width: 48%;
				}
			}

			.servicesTop {
				--leftMarg: var(--sp13x);
				--bottomMarg: -48px;
				--animationSize: 165px;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			.subtitle {
				max-width: 86%;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			--distanceBackTop: var(--sp3x);
			--distanceButtonTop: var(--sp5x);

			.servicesTop {
				--leftMarg: var(--sp15x);
				--bottomMarg: -56px;
				--animationSize: 220px;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			--distanceBackTop: var(--sp3x);
			--distanceButtonTop: var(--sp5x);

			.description {
				&.long {
					max-width: 68%;
				}

				&.short {
					max-width: 49%;
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
			--distanceBackTop: var(--sp3x);
			--distanceButtonTop: var(--sp5x);

			.description {
				&.long {
					max-width: 56%;
				}

				&.short {
					max-width: 49%;
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
			--distanceBackTop: var(--sp5x);
			--distanceButtonTop: var(--sp6x);

			.description {
				&.long {
					max-width: 61%;
				}

				&.short {
					max-width: 47%;
				}
			}

			.servicesTop {
				--leftMarg: var(--sp17x);
				--bottomMarg: -68px;
				--animationSize: 252px;
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			--distanceBackTop: var(--sp6x);
			--distanceButtonTop: var(--sp7x);

			&.underline {
				padding-bottom: var(--sp10x);
			}

			.subtitle {
				max-width: 90%;
			}

			.description {
				&.long {
					max-width: 59%;
				}

				&.short {
					max-width: 49%;
				}
			}

			.servicesTop {
				--leftMarg: var(--sp21x);
				--bottomMarg: -100px;
				--animationSize: 332px;
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			--distanceBackTop: var(--sp6x);
			--distanceButtonTop: var(--sp10x);

			&.underline {
				padding-bottom: var(--sp15x);
			}

			.subtitle {
				max-width: 90%;
			}

			.description {
				&.long {
					max-width: 51%;
				}

				&.short {
					max-width: 49%;
				}
			}

			.servicesTop {
				--leftMarg: var(--sp27x);
				--bottomMarg: -124px;
				--animationSize: 352px;
			}
		}
	}
`;

export default PageTopSectionStyle;
